export default "__VITE_ASSET__DMsMwZFU__"